<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 16/9/2020
  -->

<template>
	<div class="qwoach-dialog-root root-dialog expand-error dialog-print-position-absolute"
	:class="{'qwoach-form': addQwoachFormClass}">

		<el-dialog v-model="visible" :show-close="false" @close="onCancel()"
				   :close-on-click-modal="true"
				   :title="title"
				   :before-close="onBeforeCloseConfirm"
				   :close-on-press-escape="closeOnPressEscape" v-bind="$attrs"
				   :width="dialogWidth">
			<template #header>
				<div class="qwoach-dialog-header-row qw-row w-100">
					<slot name="title-styled" class="w-100">
						<div class="el-dialog__header__internal" v-if="hasTitle">
							<div class="el-dialog__title">
								<slot name="title">{{ dialogTitle }}</slot>
							</div>
						</div>
					</slot>
					<div class="layout-spacer"/>
					<slot name="title-right"></slot>
					<span v-if="showClose"><qw-button-icon icon="icon-cancel-1" @click="onCancel"/></span>
				</div>
			</template>


			<!--			<div class="qwoach-form">-->
			<slot></slot>
			<!--			</div>-->
			<template v-if="showFooter" #footer>

				<div class="dialog-footer text-left">
					<slot name="footer">
						<div class="dialog-footer-layout">
							<div class="dialog-footer-group dialog-footer-group-left">
							<qw-button-danger v-if="showDelete"
											  :loading="showProgressButtons"
											  plain
											  @click="onDelete()">
								{{ dialogDeleteTitle }}
							</qw-button-danger>
							<div
								v-for="actionItem in extraActions"
								:key="actionItem.id || actionItem.action"
								class="dialog-footer-action-item">
								<qw-button-danger
									v-if="actionItem.isDanger"
									:loading="showProgressButtons"
									:plain="actionItem.plain !== false"
									:disabled="actionItem.isDisabled"
									@click="onExtraAction(actionItem)">
									{{ actionItem.title }}
								</qw-button-danger>
								<qw-button
									v-else
									:loading="showProgressButtons"
									:type="actionItem.type"
									:text="actionItem.text"
									:plain="actionItem.plain"
									:disabled="actionItem.isDisabled"
									@click="onExtraAction(actionItem)">
									{{ actionItem.title }}
								</qw-button>
							</div>
							<qw-button v-if="showCancel2"
									   @click="onCancel2()" :loading="showProgressButtons">
								{{ dialogCancel2Title }}
							</qw-button>
							<div v-if="showCheckboxComputed || showCheckbox2Computed" class="dialog-footer-checkboxes">
								<div v-if="showCheckboxComputed" >
									<qw-checkbox v-model="checkboxValue" @change="onCheckboxChanged">{{checkboxTextComputed}}</qw-checkbox>
									<ToolTipView v-if="checkboxTooltipTextComputed" :text="checkboxTooltipTextComputed"/>
								</div>
								<div v-if="showCheckbox2Computed" >
									<qw-checkbox v-model="checkbox2Value" @change="onCheckbox2Changed">{{checkbox2TextComputed}}</qw-checkbox>
									<ToolTipView v-if="checkbox2TooltipTextComputed" :text="checkbox2TooltipTextComputed"/>
								</div>
							</div>
							<slot name="footer-extra"></slot>
							</div>

							<div class="layout-spacer dialog-footer-spacer"></div>
							<div class="dialog-footer-group dialog-footer-group-right">
							<qw-button v-if="showCancel" @click="onCancel()" :loading="showProgressButtons">
								{{ dialogCancelTitle }}
							</qw-button>
							<qw-link v-if="showOk && okUrl" v-bind="yesButtonParamsComputed" @click="onOk()" :disabled="!dialogIsOkEnabled">
								{{ dialogOkTitle }}
							</qw-link>
							<qw-button v-else-if="showOk" v-bind="yesButtonParamsComputed" @click="onOk()" :loading="showProgressButtons"
									   :disabled="!dialogIsOkEnabled">
								{{ dialogOkTitle }}
							</qw-button>
							</div>
						</div>
					</slot>
				</div>
			</template>

			<LoadingIndicator :text="loadingMessageComputed"
							  :is-loading="isLoadingComputed"/>
		</el-dialog>
	</div>
</template>

<script>

import {checkExtendsComponent, getParentByTypeRecursive} from "@/utils/helpers";
import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
import BaseComponent from "@/core/components/BaseComponent.vue";
import BaseQwoachDialog from "@/core/components/Dialogs/QwoachDialog/BaseQwoachDialog.vue";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";


export default {
	name: "QwoachDialogLayout",
	components: {ToolTipView, LoadingIndicator},
	extends: BaseComponent,

	inject: ["parentDialog"],

	props: {
		isLoading: {Boolean, default: false},
		loadingMessage: String,
        closeOnPressEscape: {Boolean, default: true},
		addQwoachFormClass: {Boolean, default: true},
		defaultCheckboxValue: {Boolean, default: true},
		checkboxText: String,
		checkboxTooltipText: String,
		checkbox2Text: String,
		checkbox2TooltipText: String,
		okTitle: String,
		okUrl: String,
		cancelTitle: String,
		cancel2Title: String,
		hideTitle: Boolean,
		title: String,
		showFooter: {Boolean, default: true},
		width: [Number, String],
		dontSetParentLayout: Boolean,
		dialogClass: String,
		yesButtonParams: {Object, default: () => ({})},
		showClose: Boolean,

	},

	data() {
		return {
			visible: true,
			parent: null,
			checkboxValue: false,
			checkbox2Value: false,
		}
	},

	created() {
		this.findParentDialog()
	},

	async mounted(){
		this.checkboxValue = this.defaultCheckboxValueComputed
		this.checkbox2Value = this.defaultCheckbox2ValueComputed
		this.onCheckboxChanged()
		this.onCheckbox2Changed()
	},

	methods: {

		async onBeforeCloseConfirm(closeCallback){
			console.log("onBeforeCloseConfirm: ", ...arguments)
			let res = await this.parent.onBeforeCloseConfirm(closeCallback)

			if(res !== false) { // undefined/null is ok
				closeCallback()
			}
		},

		// findParentDialog() {
		// 	let targetComponent = this.getParentComponentClass()
		// 	let parentDialogLayout = getParentByTypeRecursive(this.$parent, this.$options)
		// 	// console.warn("Nested dialogLayout found: ", parentDialogLayout)
		// 	// console.log("QwoachDialogLayout findParentDialog: this.$options.name = ", this.$options.name)
		// 	this.parent = getParentByTypeRecursive(this.$parent, targetComponent)
		// 	if(parentDialogLayout){
		// 		console.log("QwoachDialogLayout: found nested dialog layouts. Skipping setDialogLayout to parent for ", this)
		// 		return
		// 	}
		// 	if(!this.dontSetParentLayout){
		// 		if(this.parent.dialogLayout){
		// 			throw Error("this.parent.dialogLayout is already set. Are you using nested QwoachDialogLayout without setting dontSetParentLayout? Make sure to set dontSetParentLayout for all QwoachDialogLayouts in the hierarchy except one. this.parent = ", this.parent, ", this = ", this)
		// 		}
		// 		this.parent.dialogLayout = this
		// 	}
		// 	console.log("QwoachDialogLayout: this.parent = ", this.parent, ", this = ", this)
		// 	if (!checkExtendsComponent(this.parent, targetComponent)) {
		// 		throw Error(`${this.$options.name} must be placed inside a component that extends ${targetComponent.name}: found in ${this.parent.$options.name}`)
		// 	}
		// },


		findParentDialog() {
			this.parent = this.parentDialog

			if(!this.dontSetParentLayout){
				if(this.parent.dialogLayout){
					throw Error("this.parent.dialogLayout is already set. Are you using nested QwoachDialogLayout without setting dontSetParentLayout? Make sure to set dontSetParentLayout for all QwoachDialogLayouts in the hierarchy except one. this.parent = ", this.parent, ", this = ", this)
				}
				this.parent.dialogLayout = this
			}

			let targetComponent = this.getParentComponentClass()
			console.log("QwoachDialogLayout: this.parent = ", this.parent, ", this = ", this)
			if (!checkExtendsComponent(this.parent, targetComponent)) {
				throw Error(`${this.$options.name} must be placed inside a component that extends ${targetComponent.name}: found in ${this.parent.$options.name}`)
			}
		},

		getParentComponentClass(){
			return BaseQwoachDialog
		},


		$close(data) {
			this.parent.$close(data)
		},

		$error(data) {
			this.parent.$error(data)
		},

		onOk() {
			return this.parent.onOk()
		},
		onCancel() {
			return this.parent.onCancel()
		},
		onCancel2() {
			return this.parent.onCancel2()
		},
		onDelete() {
			return this.parent.onDelete()
		},
		onExtraAction(actionItem) {
			return this.parent.onExtraAction(actionItem)
		},

		onCheckboxChanged(){
			this.parent.onCheckboxChanged(this.checkboxValue)
		},
		onCheckbox2Changed(){
			this.parent.onCheckbox2Changed(this.checkbox2Value)
		}
	},

	computed: {

		yesButtonParamsComputed(){
			let defaultParams = {
				type: "primary"
			}
			return {
				...defaultParams,
				...this.yesButtonParams,

			}
		},

		hasTitle() {
			return !this.hideTitle && (this.dialogTitle || this.$slots.title)
		},

		loadingMessageComputed() {
			return this.loadingMessage || this.parent.progressText
		},

		isLoadingComputed() {
			console.log("QwoachDialogLayout.isLoadingComputed: ", this.isLoading, ", this.parent.isDataLoading = ", this.parent.isDataLoading, ", this = ", this)
			return this.isLoading || this.parent.isDataLoading
		},

		dialogTitle() {
			return this.title || this.parent.dialogTitle
		},

		dialogWidth() {
			let nn = "" + Number(this.width)
			console.log("dialogWidth 1 = ", nn)
			if("" + Number(this.width) === this.width){
				return `${this.width}px`
			}
			return this.width// ? `${this.width}px` : null
		},

		dialogOkTitle() {
			return this.okTitle || this.parent.dialogOkTitle
		},
		dialogDeleteTitle() {
			return this.parent.dialogDeleteTitle
		},

		dialogCancelTitle() {
			return this.cancelTitle || this.parent.dialogCancelTitle
		},

		dialogCancel2Title() {
			return this.cancel2Title || this.parent.dialogCancel2Title
		},

		dialogIsOkEnabled() {
			return this.parent.dialogIsOkEnabled
		},

		showCloseComputed() {
			return this.showClose || this.parent.dialogShowClose
		},
		showOk() {
			return this.parent.dialogShowOk
		},
		showDelete() {
			return this.parent.dialogShowDelete
		},
		showCancel() {
			return this.parent.dialogShowCancel
		},
		showCancel2() {
			return this.parent.dialogShowCancel2
		},
		extraActions() {
			return this.parent.dialogExtraActions || []
		},
		showCheckboxComputed(){
			return !!this.checkboxTextComputed
		},
		checkboxTextComputed(){
			return this.checkboxText || this.parent.dialogCheckboxText
		},
		checkboxTooltipTextComputed(){
			return this.checkboxTooltipText || this.parent.dialogCheckboxTooltipText
		},

		defaultCheckboxValueComputed(){
			return this.defaultCheckboxValue || this.parent.dialogDefaultCheckboxValue
		},

		showCheckbox2Computed(){
			return !!this.checkbox2TextComputed
		},

		checkbox2TextComputed(){
			return this.checkbox2Text || this.parent.dialogCheckbox2Text
		},
		checkbox2TooltipTextComputed(){
			return this.checkbox2TooltipText || this.parent.dialogCheckbox2TooltipText
		},

		defaultCheckbox2ValueComputed(){
			return this.defaultCheckbox2Value || this.parent.dialogDefaultCheckbox2Value
		},

		showProgressButtons() {
			return this.parent.showProgressButtons || this.isLoadingComputed
		},

	}
}
</script>

<style lang="scss">

.qwoach-dialog-root {
	.qwoach-dialog-header-row {
		flex-wrap: wrap;
		gap: 0.5rem;
	}

	.dialog-footer-layout {
		display: flex;
		flex-direction: column;
		align-items: stretch;
		gap: 0.5rem;
	}

	.dialog-footer-group {
		display: flex;
		flex-direction: column;
		align-items: stretch;
		gap: 0.5rem;
	}

	.dialog-footer-group > *, .dialog-footer-action-item > *{
		width: 100%;
		margin: 0 !important;
	}


	.dialog-footer-checkboxes {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
	}

	.dialog-footer-spacer {
		display: none;
	}

	&.qwoach-form {
		.el-dialog__title {
			padding: 0;
		}
	}
}

@media (min-width: 768px) {
	.qwoach-dialog-root {
		.qwoach-dialog-header-row {
			flex-wrap: nowrap;
		}

		.dialog-footer-layout {
			flex-direction: row;
			align-items: center;
		}

		.dialog-footer-group {
			flex-direction: row;
			align-items: center;
		}

		.dialog-footer-group > * {
			width: auto;
		}

		.dialog-footer-action-item {
			width: auto;
		}

		.dialog-footer-checkboxes {
			align-items: flex-start;
		}

		.dialog-footer-spacer {
			display: block;
		}
	}
}

@media print {
	.dialog-print-position-absolute {
		.el-overlay, .el-overlay-dialog {
			overflow: visible !important;
			position: absolute !important;
		}
	}
}

</style>
